module.exports = __webpack_public_path__ + "img/wizard-blog.bed0a166.png";